<mat-label class="subHeading">Sourcing Type<span *ngIf="isRequired" class="star">*</span></mat-label>
<mat-select multiple formControlName="sourcing_type" class="source" placeholder="{{isRequired ? 'Select' : 'All'}}">
    <mat-option (onSelectionChange)="selectionChange($event)" *ngFor="let sourceType of sourceTypes" [value]="sourceType">{{sourceType}}</mat-option>
</mat-select>